import React from "react";
import BaseReactSelectDropdown from "./BaseReactSelectDropdown";
import { type DropdownProps } from "../models";

const InvoiceExportMaskDropdown = (props: DropdownProps<server.dto.ExportMask, server.dto.ExportMasks>) => {
  return <BaseReactSelectDropdown
    value={props.value}
    onChange={props.onChange}
    onEsc={props.onEsc}
    options={props.options}
    getLabel={exportMask => exportMask.name}
    getValue={exportMask => exportMask.value}
    excludeKeys={[]}
    config={{
      isSearchable: false,
      ...props.config
    }}
  />
}

export default InvoiceExportMaskDropdown;